import React, { FC, ReactNode, useContext, useState } from "react";

interface IProcessesHistoryContextValue {
  expandedItems: Set<number>;
  onToggleExpanded: (id: number) => void;
}

interface IProcessesHistoryContextProps {
  children: ReactNode;
}

const ProcessesHistoryContext =
  React.createContext<IProcessesHistoryContextValue | null>(null);

export const useProcessesHistoryContext = (): IProcessesHistoryContextValue => {
  const context = useContext(ProcessesHistoryContext);
  if (!context) {
    throw new Error(
      "useProcessesHistoryContext must be used within ProcessesHistoryWrapper",
    );
  }
  return context;
};

export const ProcessesHistoryWrapper: FC<IProcessesHistoryContextProps> = ({
  children,
}) => {
  const [expandedItems, setExpandedItems] = useState<Set<number>>(new Set());

  const onToggleExpanded = (id: number): void => {
    setExpandedItems(prev => {
      const newSet = new Set(prev);
      if (newSet.has(id)) {
        newSet.delete(id);
      } else {
        newSet.add(id);
      }
      return newSet;
    });
  };

  return (
    <ProcessesHistoryContext.Provider
      value={{ expandedItems, onToggleExpanded }}
    >
      {children}
    </ProcessesHistoryContext.Provider>
  );
};
